import BaseApiManager from '../baseApiManager';
import { showError } from '../../../redux/reducers/alerts/actions';
import { store } from '../../../redux/store';

export default class ImageApi extends BaseApiManager {
  static async getInstance() {
    if (!ImageApi.instance) {
      ImageApi.instance = new ImageApi();
      ImageApi._initPromise = ImageApi.instance.init();
    }
    await ImageApi._initPromise;
    return ImageApi.instance;
  }

  async fetchImage(id, attempt = 0) {
    try {
      const res = await window.fetch(
        `${window['apiUrl']}/user/${this.userId}/image/${id}/processed`,
        {
          headers: new window.Headers({
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          }),
          method: 'GET',
        }
      );

      if (this.isSuccess(res.status)) {
        return res;
      } else if (res.status === 412 || res.status === 410) {
        return this.fetchOriginalImage(id);
      } else if (res.status === 401) {
        return this.errorHandler(
          this.fetchImage.bind(this),
          { response: { status: 401 } },
          attempt,
          id,
        );
      } else {
        store.dispatch(showError(true, `Server error when try to get processed img. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.fetchImage.bind(this), error, attempt, id);
    }
  }

  async fetchOriginalImage(id, attempt = 0) {
    try {
      const res = await window.fetch(
        `${window['apiUrl']}/user/${this.userId}/image/${id}/original`,
        {
          headers: new window.Headers({
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          }),
          method: 'GET',
        }
      );

      if (this.isSuccess(res.status)) {
        return res;
      } else if (res.status === 401) {
        return this.errorHandler(
          this.fetchOriginalImage.bind(this),
          { response: { status: 401 } },
          attempt,
          id,
        );
      } else {
        store.dispatch(showError(true, `Server error when try to get original img. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.fetchOriginalImage.bind(this), error, attempt, id);
    }
  }

  async fetchDetectedObjects(id, attempt = 0) {
    try {
      const res = await this.get(`user/${this.userId}/image/${id}/detectedObjects`);
      if (this.isSuccess(res.status)) {
        return res.data;
      } else if (res.status === 401) {
        return this.errorHandler(
          this.fetchDetectedObjects.bind(this),
          { response: { status: 401 } },
          attempt,
          id,
        );
      } else {
        store.dispatch(showError(true, `Server error when try to get detected objects. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.fetchDetectedObjects.bind(this), error, attempt, id);
    }
  }

  async deleteImage(id, attempt = 0) {
    try {
      const res = await this.delete(`user/${this.userId}/image/${id}`);

      if (this.isSuccess(res.status)) {
        return true;
      } else if (res.status === 401) {
        return this.errorHandler(
          this.deleteImage.bind(this),
          { response: { status: 401 } },
          attempt,
          id,
        );
      } else {
        store.dispatch(showError(true, `Server error when try to delete img. Status:${res.status}`));
        return false;
      }
    } catch (error) {
      return this.errorHandler(this.deleteImage.bind(this), error, attempt, id);
    }
  }

  async updateObject(count, imgId, attempt = 0) {
    try {
      const res = await this.patch(`user/${this.userId}/image/${imgId}/detectedObjectsSummary`, {
        set: +count,
      });

      if (res.status === 401) {
        return this.errorHandler(
          this.updateObject.bind(this),
          { response: { status: 401 } },
          attempt,
          imgId,
        );
      } else if (!this.isSuccess(res.status)) {
        store.dispatch(showError(true, `Server error when try to update detected objects count. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.updateObject.bind(this), error, attempt, count, imgId);
    }
  }

  async fetchUserImages(attempt = 0) {
    try {
      const res = await this.get(`user/${this.userId}/images`);

      if (this.isSuccess(res.status)) {
        return res.data.images;
      } else {
        store.dispatch(showError(true, `Server error when try to get user images. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.fetchUserImages.bind(this), error, attempt);
    }
  }

  async getShareData(imgId, attempt = 0) {
    try {
      const res = await this.put(`user/${this.userId}/image/${imgId}/share`);

      if (res.status === 401) {
        return this.errorHandler(
          this.getShareData.bind(this),
          { response: { status: 401 } },
          attempt,
          imgId,
        );
      } else if (this.isSuccess(res.status)) {
        return res.data;
      } else {
        store.dispatch(showError(true, `Server error when try to get shared token. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.getShareData.bind(this), error, attempt, imgId);
    }
  }
}
